import { Leaf, Droplets, Sun, Wrench, Shield, Flower2, Sprout, Droplet, Scissors, Sparkle, Flame } from "lucide-react";

const products = [{
        image: "fertilizante",
        title: "Fertilizante Natural",
        description: "Ideal para suas roseiras",
        longDescription: "Fertilizante 100% orgânico, perfeito para estimular o crescimento saudável e florido das suas roseiras, enriquecendo o solo com nutrientes naturais.",
        price: "R$ 49,90",
        discount: "10% OFF",
        rating: 4.5,
        icon: < Leaf className = "text-green-600"
        size = { 18 }
        />,
        category: "consumiveis"
    },
    {
        image: "irrigador",
        title: "Irrigador Automático",
        description: "Controle pelo app",
        longDescription: "Sistema inteligente de irrigação com controle via aplicativo, ideal para manter suas plantas sempre hidratadas sem esforço e com economia de água.",
        price: "R$ 129,90",
        discount: "",
        rating: 4.8,
        icon: < Droplets className = "text-blue-500"
        size = { 18 }
        />,
        category: "utensilios"
    },
    {
        image: "sementes",
        title: "Mix de Sementes",
        description: "Flores de primavera",
        longDescription: "Um conjunto selecionado de sementes para cultivar flores vibrantes e coloridas durante a primavera. Perfeito para jardins e vasos decorativos.",
        price: "R$ 35,90",
        discount: "15% OFF",
        rating: 4.2,
        icon: < Sun className = "text-yellow-500"
        size = { 18 }
        />,
        category: "consumiveis"
    },
    {
        image: "pazinha",
        title: "Pazinha de Jardim",
        description: "Compacta e resistente",
        longDescription: "Feita em aço inox com cabo ergonômico, essa pazinha facilita o plantio e a manutenção do seu jardim com conforto e durabilidade.",
        price: "R$ 19,90",
        discount: "",
        rating: 4.6,
        icon: < Wrench className = "text-gray-600"
        size = { 18 }
        />,
        category: "utensilios"
    },
    {
        image: "luvas",
        title: "Luvas de Jardinagem",
        description: "Proteja suas mãos",
        longDescription: "Luvas confortáveis com revestimento resistente à abrasão e umidade, ideais para proteger suas mãos durante a jardinagem.",
        price: "R$ 24,90",
        discount: "5% OFF",
        rating: 4.4,
        icon: < Shield className = "text-pink-500"
        size = { 18 }
        />,
        category: "utensilios"
    },
    {
        image: "ceramica",
        title: "Vaso de Cerâmica",
        description: "Estilo rústico artesanal",
        longDescription: "Vaso artesanal em cerâmica com acabamento rústico, perfeito para dar um toque de charme e personalidade ao seu jardim ou ambiente interno.",
        price: "R$ 59,90",
        discount: "",
        rating: 4.7,
        icon: < Flower2 className = "text-red-400"
        size = { 18 }
        />,
        category: "decoracoes"
    },
    {
        image: "terra",
        title: "Terra Vegetal Enriquecida",
        description: "Ideal para o crescimento saudável",
        longDescription: "Composta por matéria orgânica e minerais essenciais, essa terra vegetal é perfeita para promover o crescimento vigoroso de plantas e flores.",
        price: "R$ 39,90",
        discount: "20% OFF",
        rating: 4.9,
        icon: < Sprout className = "text-brown-600"
        size = { 18 }
        />,
        category: "consumiveis"
    },
    {
        image: "liquido",
        title: "Adubo Líquido Orgânico",
        description: "Nutrição rápida para suas plantas",
        longDescription: "Adubo orgânico em forma líquida para absorção rápida, fornecendo os nutrientes necessários para o crescimento saudável das plantas em vasos ou jardins.",
        price: "R$ 29,90",
        discount: "10% OFF",
        rating: 4.3,
        icon: < Droplet className = "text-green-500"
        size = { 18 }
        />,
        category: "consumiveis"
    },
    {
        image: "poda",
        title: "Tesoura de Poda",
        description: "Corte preciso e confortável",
        longDescription: "Tesoura com lâminas afiadas e empunhadura anatômica, garantindo cortes limpos e precisos para podas regulares de galhos e folhagens.",
        price: "R$ 45,90",
        discount: "",
        rating: 4.6,
        icon: < Scissors className = "text-gray-800"
        size = { 18 }
        />,
        category: "utensilios"
    },
    {
        image: "iniciantes",
        title: "Kit Iniciante de Jardinagem",
        description: "Tudo que você precisa para começar",
        longDescription: "Kit completo com ferramentas básicas, sementes e orientações, ideal para quem está começando a se aventurar no mundo da jardinagem.",
        price: "R$ 89,90",
        discount: "12% OFF",
        rating: 4.8,
        icon: < Sparkle className = "text-purple-500"
        size = { 18 }
        />,
        category: "conjuntos"
    },
    {
        image: "aromatica",
        title: "Vela Aromática Floral",
        description: "Perfume suave de lavanda",
        longDescription: "Vela artesanal com essência de lavanda, perfeita para criar um ambiente relaxante e acolhedor em qualquer cômodo da casa.",
        price: "R$ 22,90",
        discount: "",
        rating: 4.1,
        icon: < Flame className = "text-orange-400"
        size = { 18 }
        />,
        category: "consumiveis"
    },
];

export default products;